import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Input } from '@angular/core';
import AngularBroadcastHelperService from '../../services/angular-broadcast-helper.service';
import {TableCreatedTrainingProgramComponent} from "../table-created-training-program/table-created-training-program.component";
import {ListPagerComponent} from "../list-pager/list-pager.component";

@Component({
	standalone: true,
	selector: 'card-created-training-program',
	templateUrl: './card-created-training-program.component.html',
	imports: [CommonModule, TableCreatedTrainingProgramComponent, ListPagerComponent, FormsModule]
})
export class CardCreatedTrainingProgramComponent implements OnInit {
	private angularBroadcastHelperService: AngularBroadcastHelperService = inject(AngularBroadcastHelperService);
	
	@Input() pageSize: any | undefined;
	@Input() trainingProgramCode: any | undefined;

	vm: any = undefined;
	
	constructor() {
		this.vm = this;
	}
	
	ngOnInit() {
		this.vm.programs = [];
		this.vm.pageSize = 10;
		this.vm.trainingProgramCode = this.trainingProgramCode;
	}
	
	currentPageChanged(newPage) {
		this.vm.currentPage = newPage;
		this.angularBroadcastHelperService.rootBroadcast("loadMorePages", newPage);
	}
	
}